var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "login-page" }, [
    _vm._m(0),
    _c("div", { staticClass: "login-page-right" }),
    _c("div", { staticClass: "login-box" }, [
      _c(
        "div",
        { staticClass: "login-box-inner" },
        [
          _vm.businessType === "login"
            ? _c("div", { staticClass: "login-box-title" }, [
                _c("div", { staticClass: "login-box-t1" }, [
                  _vm._v("欢迎登录"),
                ]),
                _c("div", { staticClass: "login-box-t2" }, [
                  _vm._v("云滴出行 随心而行"),
                ]),
              ])
            : _c("div", { staticClass: "login-box-title" }, [
                _c("div", { staticClass: "login-box-t1" }, [
                  _vm._v("忘记密码"),
                ]),
                _c("div", { staticClass: "login-box-t2" }, [
                  _vm._v("新密码将通过短信形式发送到对应手机号"),
                ]),
              ]),
          _c("login-panel"),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "login-page-left" }, [
      _c("div", { staticClass: "login-page-left-content" }, [
        _c("img", {
          attrs: { src: require("@/static/login/login-title.png") },
        }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }